/**
 * BasicModel object
 */
export class BasicModel {
  id = 0;

  constructor(props) {
    this.setProps(props);
  }

  setProps(props) {
    BasicModel.updateObjectProps(props, this);
  }

  static updateObjectProps(props, mainObject) {
    Object.keys(props).forEach((prop) => {
      if (mainObject[prop] !== undefined && props[prop] !== undefined) {
        mainObject[prop] = props[prop];
      }
    });
  }

  /**
   * Return the params that should be used to update this data
   * @return {Object}
   */
  /* eslint-disable-next-line class-methods-use-this */
  get updateQueryParams() {
    return {};
  }
}

export default {
  BasicModel,
};
